export const LOGLINE =
  "MINKA has the foundation for a compelling supernatural horror film: an isolated Japanese farmhouse, a hidden family curse, a warrior ghost, a descent into hell, and an American-born Japanese heroine forced to confront a past her mother concealed. The combination of atmospheric horror, Japanese martial arts, cultural discovery, and romance gives it potential to appeal to both horror audiences and viewers who enjoy emotionally driven supernatural stories.";

export const CONCEPT = [
  "MINKA is a classic haunted-house story with a contemporary twist—a collision of supernatural romance, psychological horror, and Japanese mythology. Blending the dark romantic appeal of Twilight with the chilling supernatural terror of The Ring, the film transports audiences into a mysterious world where ancient traditions and modern life collide.",
  "Her journey leads into a nightmarish underworld where courage, sacrifice, and the truth about her family's past become her only weapons. Against impossible odds, Rika discovers a strength she never knew she possessed—and finds that love may be waiting on the other side of her darkest trial.",
];

export const CHAPTERS = [
  {
    num: "I",
    kanji: "相続",
    title: "The Inheritance",
    slug: "EXT. SAN FRANCISCO / IWATE PREFECTURE — DUSK",
    blocks: [
      { p: "Born in America to Japanese parents, Rika has struggled to establish herself as an artist in a cramped San Francisco apartment. When both her parents die in a mysterious accident, settling their affairs in Japan reveals a secret: her mother owned a magnificent ancestral farmhouse—a minka—hidden deep in the mountains of northern Iwate Prefecture, a region ominously associated with the name “Devil's Hand.”" },
      { p: "On the journey, Rika begins seeing figures no one else can see. The shuttered farmhouse she finds is both a haunting relic and a place of extraordinary beauty, and she resolves to restore it into a bed-and-breakfast—a place she can finally belong." },
      { pull: "But something in the house does not want her there." },
      { p: "A sinister samurai spirit stalks the corridors. A crude gang of Satanic bikers menaces her new life. And something far more ancient is bound to the property—and to her family—by forces that have endured for centuries." },
    ],
  },
  {
    num: "II",
    kanji: "呪い",
    title: "The Curse",
    slug: "INT. MINKA FARMHOUSE — NIGHT",
    blocks: [
      { p: "As a handsome local carpenter helps restore the house, attraction grows—but so do the hauntings. His uncle, a Buddhist priest, attempts a spiritual intervention. It fails, and instead exposes a hidden doorway behind the great Shinto shrine: an underground chamber holding a portal to Hell, source of a curse born in the betrayal of a samurai woman centuries ago." },
      { pull: "Rika faces an impossible choice: abandon the house, or fight. She chooses to fight." },
      { p: "She submits to grueling training in budō and the sword, guided by spiritual teaching—and shaves her head as a symbol of her renunciation of fear." },
    ],
  },
  {
    num: "III",
    kanji: "地獄",
    title: "The Descent",
    slug: "INT. UNDERWORLD — ETERNAL NIGHT",
    blocks: [
      { p: "Rika enters the portal and descends a multi-level underworld of trials that test her courage, discipline, and resolve—each revealing how deeply the curse is tied to her family, and to her mother's hidden history." },
      { p: "In a climactic confrontation she survives a flaming demon, uncovers the truth of the ancient betrayal, releases the samurai spirit from its endless purgatory, and breaks the cycle of vengeance." },
      { pull: "Against all odds, Rika emerges victorious." },
      { p: "Welcomed home by a jubilant village, she reclaims the house—and discovers belonging, renewed purpose, and the possibility of lasting love." },
    ],
  },
];

export const CLOSING =
  "MINKA is a supernatural journey into the heart of Japanese folklore, where the past refuses to die, the road to redemption leads through Hell, and one woman's determination may be the only force capable of breaking a centuries-old curse.";

export const SPECS = [
  { k: "Written by", v: "Nicola Davis" },
  { k: "Genre", v: "Supernatural Thriller / Horror" },
  { k: "Setting", v: "Modern-day Japan — the remote northern mountains of Iwate Prefecture" },
  { k: "Tone", v: "Twilight's dark romance × The Ring's supernatural terror" },
];
